import { OfflineDataFetcher } from '@skinsoft/data-store/src/offline/offline-data-fetcher';

import { Work } from '@skinsoft/entity/'
import { Observable } from 'rxjs';
import { map, pluck, tap, } from 'rxjs/operators';


export class WorkOfflineDataFetcher extends OfflineDataFetcher<Work>{

    constructor(cacheKey: string) {
        super(cacheKey);
    }

    public fetchOneFromId(id: string): Observable<Work> {
        return super.fetchOneFromId(id)
            .pipe(
                map(obj => obj || {}),
                pluck('work')
            )
    }

    public fetchWemiFromId(id: string): Observable<any> {
        return super.fetchOneFromId(id)
    }

    protected idMatcher(entity: any, id: string) {
        if (entity.work) {
            return entity.work.id === id;
        }
        return false;
    }

}